<template>
  <PageWrapper :logo="true">
    <Alert v-if="success" class="success" icon="check">
      You have been successfully removed from the mailing list.
    </Alert>
    <DividerSeparator v-else class="wide">
      <Loader />
      <div slot="title">Removing you from the mailing list</div>
    </DividerSeparator>
  </PageWrapper>
</template>

<script>
import Loader from "vue-spinner/src/BounceLoader";

export default {
  name: "profile-unsubscribe",
  components: { Loader },
  data: function() {
    return {
      success: false
    };
  },
  mounted: function() {
    setTimeout(() => {
      this.services.UserResource.unsubscribe({
        id: this.$route.params.id
      }).then(() => {
        this.success = true;
      });
    }, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
